import { put, call, takeLatest } from 'redux-saga/effects'
import { get, post } from '../../helpers/server'

function* getScanSectors(action) {
    try {
        //const resp = yield call(get, "/filter/scanSectors?u=" + action.payload.UserId + "&spk=" + action.payload.stockPoolKey + "&sg=" + action.payload.stockGroups);
        const resp = yield call(post, "/filter/scanSectors", action.payload);
        if (resp.status === 1) {
            if (resp.sg !== null) {
                sessionStorage.setItem("CustomStockGroupsCache", JSON.stringify(resp.sg));
            }
            yield put({ type: "get_scan_sectors_success", sectors: resp.s, stockCount: resp.sc, naturalLangFormulas: resp.nlf });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_scan_sectors_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_scan_sectors_fail", status: 0 });
    }
}

function* clearFilterString() {
    yield put({ type: 'clear_filter_string' });
}

function* auth() {
    yield takeLatest('action_get_scan_sectors', getScanSectors);

    yield takeLatest('action_clear_filterString', clearFilterString);
    
}

export default auth;